<template>
  <div class="order-manage">
    <div class="container">
      <div class="condition">
        <e-search
          :count="100"
          :data="filterInfo.data"
          :field-list="filterInfo.fieldList"
          :list-type-info="listTypeInfo"
          :width="filterInfo.width"
          @handleFilter="handleFilter"
          @handleEvent="handleEvent"
          @handleReset="handleReset"
        ></e-search>
      </div>
    </div>
    <div class="container">
      <!-- <div class="wrapper"> -->
      <div class="crumbs">
        <el-breadcrumb separator=" ">
          <el-breadcrumb-item>
            <i class="el-icon-lx-cascades"></i> 订单列表
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            <el-button style="margin-top: -10px" @click="orderTime">
              下单时间
              <i
                class="el-icon-top"
                v-if="
                  query.orderByColumnNameType == '1' &&
                  query.orderByRuleType == '1'
                "
              ></i>
              <i
                class="el-icon-bottom"
                v-if="
                  query.orderByColumnNameType == '1' &&
                  query.orderByRuleType == '0'
                "
              ></i>
            </el-button>
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            <el-button style="margin-top: -10px" @click="orderPrice">
              订单价格
              <i
                class="el-icon-top"
                v-if="
                  query.orderByColumnNameType == '2' &&
                  query.orderByRuleType == '1'
                "
              ></i>
              <i
                class="el-icon-bottom"
                v-if="
                  query.orderByColumnNameType == '2' &&
                  query.orderByRuleType == '0'
                "
              ></i>
            </el-button>
          </el-breadcrumb-item>
          <div style="float: right">
            <el-breadcrumb-item>
              <el-button style="margin-top: -10px" @click="exportOrder"
                >导出订单概要</el-button
              >
            </el-breadcrumb-item>
            <el-breadcrumb-item>
              <el-button style="margin-top: -10px" @click="exportDetail"
                >导出订单明细</el-button
              >
            </el-breadcrumb-item>
          </div>
        </el-breadcrumb>
      </div>
      <TableList
        :loading="loading"
        :table-data="tableData"
        :table-label="tableLabel"
        @handleSortChange="handleSortChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <template #purchaseCompany="{ scope }">
          <e-tooltip :content="scope.row.purchaseCompany" :set-length="20" />
          <div class="message" @click="openMessage(scope.row)">
            <img :src="messageImg" />
            发送留言
          </div>
        </template>
        <template v-slot:operate="slot">
          <div class="operate" v-if="slot.scope.row.skuJson">
            <eui-btn
              font-size="12"
              type="text"
              @click="handleButton(slot.scope.row, 'handleOrderDetail')"
            >
              查看详情
            </eui-btn>
            <eui-btn
                    font-size="12"
                    type="text"
                    @click="handleButton(slot.scope.row, 'handleOrderConfirm')"
                    v-if="slot.scope.row.orderStatusNum == '17'"
            >
              查看并确认
            </eui-btn>

            <!--华东小程序不展示-->
            <template v-if="!hdOrderSource.includes(Number(slot.scope.row.orderSource))">

              <eui-btn
                      font-size="12"
                      type="text"
                      @click="handleButton(slot.scope.row, 'handleDeliveryDialog')"
                      v-if="slot.scope.row.showDeliverFlag"
              >
                发货
              </eui-btn>
              <eui-btn
                      font-size="12"
                      type="text"
                      @click="handleButton(slot.scope.row, 'handleChangeConfirm')"
                      v-if="slot.scope.row.orderStatusNum == '72'"
              >
                变更确认
              </eui-btn>
              <eui-btn
                      font-size="12"
                      type="text"
                      @click="handleButton(slot.scope.row, 'handleCancleConfirm')"
                      v-if="slot.scope.row.orderStatusNum == '71'"
              >
                确认取消
              </eui-btn>
              <eui-btn
                      font-size="12"
                      type="text"
                      @click="handleButton(slot.scope.row, 'handleInvoiceList')"
                      v-if="slot.scope.row.hasReceived === 1"
              >
                查看发货单
              </eui-btn>
              <eui-btn
                      v-if="isRawMaterials"
                      font-size="12"
                      type="text"
                      @click="handleRelateNo(slot.scope.row.orderId)"
              >
                原材料管理
              </eui-btn>
              <eui-btn
                      font-size="12"
                      type="text"
                      @click="handleButton(slot.scope.row, 'handlePrint')"
                      v-if="isCanPrint(slot.scope.row.orderStatusNum)"
              >
                打印
              </eui-btn>
            </template>

          </div>
        </template>
        <template v-slot:orderSource="slot">
          {{ formatOrderSource(slot.scope.row.orderSource) }}
        </template>
        <!-- <template v-slot:aiCheckResult="{ scope: { row } }">
          <div @click="showCheckResult(row.requestId, row.aiCheckResult)">
            {{ row.aiCheckResult }}
          </div>
        </template> -->
      </TableList>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="orderTagPage.currentPage"
          :page-size="orderTagPage.pageSize"
          :total="orderTagPage.pageTotal"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
      <!-- </div> -->
      <MessageBoard
        :visible="messageVisible"
        :setVisible="setVisible"
        :current="current"
        :content="content"
      />
      <!--原材料管理-->
      <relate-no-dialog
        v-if="relateNoVisible"
        :relateNoVisible.sync="relateNoVisible"
        :relateNoData="relateNoData"
        @confirmRelateNo="confirmRelateNo"
      />
      <!--AI审查建议结果-->
      <!--type:1:sku;2:库存单;3:采购意向单成品现货；4：石化商城成品现货-->
      <AIDataReport
        v-if="dataReportVisible"
        :dataReportVisible.sync="dataReportVisible"
        type="1"
        :targetId="targetId"
      />
    </div>
  </div>
</template>

<script>
import TableList from '../../components/common/e-table-list';
import api from '../../api/order';
import eSearch from '../../components/common/e-search';
import eTooltip from '../../components/common/e-tooltip';
import utils from '@/modules/projectA/utils/utils';
import MessageBoard from '@/modules/projectA/components/messageBoard';
import { mapState } from 'vuex';
import relateNoDialog from './common/relateNoDialog';
import AIDataReport from '../../components/common/AIDataReport';
import {epecMallUrl} from '@/modules/projectA/api/config';

export default {
  components: {
    TableList,
    eSearch,
    MessageBoard,
    eTooltip,
    relateNoDialog,
    AIDataReport,
  },
  computed: { ...mapState(['USERINFO']) },
  props: {},
  name: 'orderManage',
  data() {
    return {
      hdOrderSource: [11, 12, 13],//华东小程序

      nanJingWhiteData: false,

      relateNoVisible: false,
      relateNoData: Object,

      content: '',
      messageImg: require('@/assets/img/messageBoard/message.svg'),
      messageVisible: false,
      current: {},
      filterInfo: {
        data: {
          orderNo: null,
          purchaseCompany: null,
          priceRange: null,
          orderStatus: null,
          submitTime: null,
          startTime: null,
          endTime: null,
          startAmount: null,
          endAmount: null,
          paymentMethod: null,
        },
        fieldList: [
          {
            label: '订单编号',
            type: 'input',
            value: 'orderNo',
          },
          {
            label: '采购商名称',
            type: 'input',
            value: 'purchaseCompany',
          },
          {
            label: '订单状态',
            type: 'select',
            value: 'orderStatus',
            list: 'orderStatus',
          },
          {
            label: '下单时间',
            type: 'date',
            value: 'submitTime',
            dateType: 'datetimerange',
          },
          {
            label: '价格范围',
            type: 'numRange',
            value1: 'startAmount',
            value2: 'endAmount',
            rangeWidth: 'min-width',
          },
          {
            label: '订单类型',
            type: 'select',
            value: 'orderSource',
            list: 'orderSource',
          },
          {
            label: '付款方式',
            type: 'cascader',
            value: 'paymentMethod',
            list: 'paymentMethodList',
          },
        ],
        /**配置项 */
        btnStyle: [
          {
            icon: 'el-icon-search',
            text: '过滤',
            type: 'primary',
          },
          {
            icon: 'el-icon-refresh',
            text: '重置',
          },
        ],
        width: {
          labelWidth: 80,
          itemWidth: 220,
        },
      },
      listTypeInfo: {
        orderSource: [
          {
            id: null,
            name: '全部类别',
          },
          {
            id: [1, 2, 6],
            name: '普通订单',
          },
          {
            id: 3,
            name: '一体化订单',
          },
          {
            id: 4,
            name: '询比价订单',
          },
          {
            id: 9,
            name: '招标订单',
          },
          {
            id: [5, 31],
            name: '融合集成订单',
          },
          {
            id: 10,
            name: '非标订单',
          },
          {
            id: 21,
            name: '标品比价',
          },
          {
            id: [11, 12, 13],
            name: '合金不锈订单',
          },
        ],
        orderStatus: [
          { id: 'null', name: '全部状态' },
          {
            id: '17',
            name: '待供应商确认',
          },
          {
            id: '18',
            name: '待采购商确认',
          },
          {
            id: '12',
            name: '待审批',
          },
          {
            id: '72',
            name: '变更中',
          },
          {
            id: '21',
            name: '待采购商付款',
          },
          //现在已经不用了，用paymentStatus = '3'
          // {
          //   id: "104",
          //   name: "付款中"
          // },
          {
            id: '32',
            name: '待发货',
          },
          {
            id: '4',
            name: '待收货',
          },
          {
            id: '8',
            name: '待评价',
          },
          {
            id: '6',
            name: '交易完成',
          },
          {
            id: '7',
            name: '已取消',
          },
        ],
        paymentMethodList: [
          {
            value: 1,
            label: '在线支付',
            children: [
              { value: 0, label: '直接支付' },
              { value: 1, label: '担保支付' },
              { value: 3, label: '网银支付' },
              { value: 4, label: '扫码支付' },
            ],
          },
          {
            value: 0,
            label: '线下支付',
            children: [
              { value: 101, label: '网银转账' },
              { value: 102, label: '承兑汇票' },
              { value: 103, label: '现金' },
              { value: 104, label: '支票' },
            ],
          },
        ],
      },
      iconStatus: true,
      btnHidden: false,
      loading: false,
      selectFlag: false,
      showFlag: false,
      query: {
        orderNo: null,
        orderStatus: null,
        purchaseCompany: null,
        startTime: null,
        endTime: null,
        orderType: null,
        startAmount: null,
        endAmount: null,
        submitTime: null,
        orderByColumnNameType: 1,
        orderByRuleType: 1,
        orderSourceList: null,
        paymentMethod: [], //付款方式
        payType: null, //1 在线支付  0 线下支付
        onLinePayType: null, //在线支付类型 0 ：直接支付； 1：担保支付；3：网银支付；4：扫码支付；
        offLinePayType: null, //线下支付类型 101 ：网银转账； 102：承兑汇票；103：现金；104：支票；
      },
      tableData: [],
      tableLabel: [
        { label: '订单编号', param: 'orderNo', align: 'center', width: '170' },
        {
          label: '采购商名称',
          slot: 'purchaseCompany',
          align: 'center',
          minWidth: '150',
        },
        {
          label: '订单状态',
          param: 'orderStatus',
          align: 'center',
          width: '140',
          render: (row) => {
            if (row.orderStatus == '待付款') {
              return '待采购商付款';
            } else {
              return row.orderStatus;
            }
          },
        },
        {
          label: '订单总价(元)',
          param: 'needPay',
          align: 'center',
          minWidth: '150',
        },
        {
          label: '订单类型',
          param: 'orderSource',
          align: 'center',
          slot: 'orderSource',
          width: '150',
        },
        {
          label: '下单时间',
          param: 'submitTime',
          align: 'center',
          width: '150',
        },
        // {
        //   label: '文件辅助审查',
        //   param: 'aiCheckResult',
        //   align: 'center',
        //   width: '150',
        //   slot: 'aiCheckResult',
        // },
        { label: '操作', minWidth: '260', slot: 'operate', fixed: 'right' },
      ],
      orderTagPage: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      orderDetail: {
        orderId: null,
        purchaseCompanyId: null,
        orderNo: null,
      },
      orderId: null,
      isSalkLake: false,
      uniqueId: null,

      dataReportVisible: false,
      targetId: '',
      isRawMaterials: false,
    };
  },
  activated() {
    const time = this.$route.query.t;
    console.log(this.$route.query);
    if (time && time !== this.uniqueId) {
      this.uniqueId = time;
      this.query = {
        orderNo: null,
        orderStatus: null,
        purchaseCompany: null,
        startTime: null,
        endTime: null,
        orderType: null,
        startAmount: null,
        endAmount: null,
        submitTime: null,
        orderByColumnNameType: 1,
        orderByRuleType: 1,
        orderSourceList: null,
      };
      this.orderTagPage.currentPage = 1;
      this.judgeQueryData();
    }
  },
  created() {
    const { from, orderNo } = this.$route.query;
    if (from === 'workbench') {
      this.filterInfo.data.orderNo = orderNo;
      this.query.orderNo = orderNo;
    }

    this.handleSearch();
    this.handleFilter();

    this.nanJingWhiteData = JSON.parse(
      localStorage.getItem('nanJingWhiteData')
    );
    this.checkIsRawMaterials();
  },
  methods: {
    async checkIsRawMaterials() {
      const res = await api.isRawMaterials();
      if (res.code === '200') {
        this.isRawMaterials = res.data;
        console.log(this.isRawMaterials);
      }
    },
    showCheckResult(requestId, aiCheckResult) {
      if (aiCheckResult === '审查不通过') {
        // this.targetId = orderId;
        // this.dataReportVisible = true;

        window.open(`${epecMallUrl}/intelligentReview?id=${requestId}`, '_blank');
      }
    },
    handleRelateNo(orderId, purchaseCompanyId) {
      this.relateNoVisible = true;
      this.orderId = orderId;
      this.relateNoData = {
        orderId,
      };
    },
    //确认 关联单号
    async confirmRelateNo(addSelectData) {
      const purchaseOrderIdList = addSelectData.map((item) => item.orderId);
      let params = {
        supplierOrderId: this.orderId,
        purchaseOrderIdList: purchaseOrderIdList,
      };
      let res = await api.orderManageBind(params);
      if (res.code === '200') {
        this.$message.success('成功关联石化订单。');
        this.selectOrder();
      }
    },
    setVisible(bool) {
      this.messageVisible = bool;
    },
    openMessage(row) {
      console.log(row);
      this.content = `订单编号：${row.orderNo}`;
      const { purchaseCompany, purchaseCompanyId } = row;
      this.current = {
        ...row,
        replyCompanyName: purchaseCompany,
        replyCompanyId: purchaseCompanyId,
      };
      this.messageVisible = true;
    },
    handleReset() {
      this.query = {
        orderNo: null,
        orderStatus: null,
        purchaseCompany: null,
        startTime: null,
        endTime: null,
        orderType: null,
        startAmount: null,
        endAmount: null,
        submitTime: null,
        orderByColumnNameType: 1,
        orderByRuleType: 1,
        orderSourceList: null,
        paymentMethod: [], //付款方式
        payType: null, //1 在线支付  0 线下支付
        onLinePayType: null, //在线支付类型 0 ：直接支付； 1：担保支付；3：网银支付；4：扫码支付；
        offLinePayType: null, //线下支付类型 101 ：网银转账； 102：承兑汇票；103：现金；104：支票；
      };
      // this.queryOrderList();
      this.judgeQueryData();
    },
    handleEvent(val) {
      let start = new Date(val.value[0]);
      this.query.startTime = this.dataFormate(start);
      let end = new Date(val.value[1]);
      this.query.endTime = this.dataFormate(end);
    },
    handleFilter(val) {
      this.selectFlag = true;
      if (val) {
        this.query.orderNo = val.orderNo;
        this.query.purchaseCompany = val.purchaseCompany;
        if (val.orderStatus == 21) {
          this.query.orderStatus = null;
          this.query.orderStatusList = [21, 22, 103];
        } else if (val.orderStatus == 32) {
          this.query.orderStatus = null;
          this.query.orderStatusList = [31, 32];
        } else {
          this.query.orderStatus = val.orderStatus;
          this.query.orderStatusList = null;
        }
        this.query.startAmount = val.startAmount;
        this.query.endAmount = val.endAmount;
        this.query.pageNum = 1;
        this.query.pageSize = 10;
        this.query.pageTotal = 0;
        this.orderTagPage.currentPage = 1;
        this.query.orderSourceList = val.orderSource;
        if (!val.submitTime) {
          this.query.startTime = null;
          this.query.endTime = null;
        }

        if (val.paymentMethod && val.paymentMethod.length > 0) {
          const firstVal = val.paymentMethod[0];
          this.query.paymentMethod = val.paymentMethod;
          this.query.payType = firstVal;
          this.query.onLinePayType =
            firstVal === 1 ? val.paymentMethod[1] : null;
          this.query.offLinePayType =
            firstVal === 1 ? null : val.paymentMethod[1];
        } else {
          this.query.paymentMethod = [];
          this.query.payType = null;
          this.query.onLinePayType = null;
          this.query.offLinePayType = null;
        }
      }
      // this.queryOrderList();
      this.judgeQueryData();
    },
    //下单时间
    orderTime() {
      this.query.orderByColumnNameType = 1;
      if (this.query.orderByRuleType == 1) {
        this.query.orderByRuleType = 0;
      } else {
        this.query.orderByRuleType = 1;
      }
      // this.queryOrderList();
      this.judgeQueryData();
    },
    //导出订单概要
    exportOrder() {
      api.exportSupplierOrderList(this.query).then((res) => {
        if (res.type == 'application/json') {
          utils.fileExportResponseError(res);
        } else {
          utils.downFile(res);
        }
      });
    },
    //导出订单明细
    exportDetail() {
      api.exportSupplierOrderSkuList(this.query).then((res) => {
        if (res.type == 'application/json') {
          utils.fileExportResponseError(res);
        } else {
          utils.downFile(res);
        }
      });
    },
    //订单价格
    orderPrice() {
      this.query.orderByColumnNameType = 2;
      if (this.query.orderByRuleType == 1) {
        this.query.orderByRuleType = 0;
      } else {
        this.query.orderByRuleType = 1;
      }
      // this.queryOrderList();
      this.judgeQueryData();
    },
    handleSearch() {
      this.query.pageNum = 1;
      // this.queryOrderList();
      this.judgeQueryData();
    },
    //打印
    isCanPrint(orderStatusNum) {
      let arr = [17, 18, 12, 71, 72, 7];
      return !arr.includes(Number(orderStatusNum));
    },
    async handleButton(row, flag) {
      this.orderDetail.orderId = row.orderId;
      this.orderDetail.purchaseCompanyId = row.purchaseCompanyId;
      this.orderDetail.orderNo = row.orderNo;
      this.orderDetail.purchaseRequestType = row.purchaseRequestType;

      //西域震坤行 限制 供应商权限  true不显示，false 显示
      let arr = ['handleOrderConfirm', 'handleDeliveryDialog'];

      //判断 采购商城订单  入参 当前 供应商id  西域震坤行 限制 供应商 收货 、确认  true 集成不显示，false 显示
      await api
        .companyWhetherSystemIntegrationByCompanyId({
          companyId: this.USERINFO.companyId,
          createTime: row.submitTime,
        })
        .then((res) => {
          if (res.code == '200') {
            this.showFlag = res.data;
          }
        });

      //供应商为集成对接供应商  ，询比价的可以操作  orderSource =4 || purchaseRequestType =4 || orderSource = 9
      if (
        this.showFlag &&
        arr.includes(flag) &&
        !(
          Number(row.orderSource) === 4 ||
          Number(row.purchaseRequestType) === 4 ||
          Number(row.orderSource) === 9
        )
      ) {
        this.$message.warning(
          '您好，该供应商已做集成对接，请在贵方平台进行操作。'
        );
        return false;
      }

      if (flag === 'handleOrderDetail') {
        // this.handleOrderDetail();
        if (this.hdOrderSource.includes(Number(row.orderSource))) {//华东小程序
          this.$router.push({
            path: '/HDOrderDetailOrConfirm',
            query: {type: 'orderDetail', ...this.orderDetail},
          }); //详情
        } else {
          this.$router.push({
            path: '/orderDetailOrConfirm',
            query: {type: 'orderDetail', ...this.orderDetail},
          }); //详情
        }
      }
      //取消订单
      if (flag === 'handleCancleConfirm') {
        this.$router.push({
          path: '/orderDetailOrConfirm',
          query: { type: 'orderCancle', ...this.orderDetail },
        });
      }
      if (flag === 'handleChangeConfirm') {
        this.$router.push({
          path: '/orderChange',
          query: { ...this.orderDetail },
        });
      }

      if (flag === 'handleOrderConfirm') {
        if (this.hdOrderSource.includes(Number(row.orderSource))) {//华东小程序
          this.$router.push({
            path: '/HDOrderDetailOrConfirm',
            query: {type: 'orderConfirm', ...this.orderDetail},
          }); //详情
        } else {
          this.$router.push({
            path: '/orderDetailOrConfirm',
            query: {type: 'orderConfirm', ...this.orderDetail},
          }); //确认
        }
      }
      if (flag === 'handleDeliveryDialog') {
        this.$router.push({
          path: '/orderDeliverDetail',
          query: { ...this.orderDetail },
        }); //发货handlePrint
        // this.handleDeliveryDialog();
      }
      if (flag === 'handlePrint') {
        let newpage = this.$router.resolve({
          name: 'e-print',
          query: { ...this.orderDetail },
        });
        window.open(newpage.href, '_blank');
      }
      if (flag === 'handleInvoiceList') {
        this.$router.push({
          // path: '/invoiceList',
          path: '/invoiceListDetail',
          query: {
            ...this.orderDetail,
            isOnLinePay: row.isOnLinePay,
            companyPayType: row.companyPayType,
          },
        });
      }
    },
    handleSortChange(e) {
      if (e.column.label === '订单总价(元)') {
        this.query.orderByColumnNameType = 2;
        if (this.query.orderByRuleType == 1) {
          this.query.orderByRuleType = 0;
        } else {
          this.query.orderByRuleType = 1;
        }
        // this.queryOrderList();
      } else if (e.column.label === '下单时间') {
        this.query.orderByColumnNameType = 1;
        if (this.query.orderByRuleType == 1) {
          this.query.orderByRuleType = 0;
        } else {
          this.query.orderByRuleType = 1;
        }
        // this.queryOrderList();
      }
      this.judgeQueryData();
    },
    dataFormate(time) {
      let arr = (
        time.getFullYear() +
        '-' +
        (time.getMonth() + 1) +
        '-' +
        time.getDate()
      ).split('-');
      if (arr[1].length == 1) {
        arr[1] = '0' + arr[1];
      }
      if (arr[2].length == 1) {
        arr[2] = '0' + arr[2];
      }
      return arr[0] + '-' + arr[1] + '-' + arr[2];
    },
    handleSelectionChange() {
      if (this.query.submitTime) {
        let start = new Date(this.query.submitTime[0]);
        this.query.startTime = this.dataFormate(start);
        let end = new Date(this.query.submitTime[1]);
        this.query.endTime = this.dataFormate(end);
      }
      this.orderTagPage.currentPage = 1;
      this.orderTagPage.pageSize = 10;
      // this.queryOrderList();
      this.judgeQueryData();
    },

    handleSizeChange(pageSize) {
      this.orderTagPage.pageSize = pageSize;
      this.orderTagPage.currentPage = 1;
      this.query.pageNum = 1;
      this.query.pageSize = pageSize;
      // this.queryOrderList();
      this.judgeQueryData();
    },
    handleCurrentChange(currentPage) {
      this.orderTagPage.currentPage = currentPage;
      this.query.pageNum = currentPage;
      // this.queryOrderList();
      this.judgeQueryData();
    },

    judgeQueryData() {
      console.log(
        this.USERINFO.companyId,
        process.env.NODE_ENV,
        'this.USERINFO.companyId'
      );
      //指定公司
      let companyIdData = '';
      if (process.env.NODE_ENV === 'production') {
        companyIdData = '8908145';
      } else {
        companyIdData = '137812';
      }

      if (String(this.USERINFO.companyId) === companyIdData) {
        this.queryEMaoListOrder();
      } else {
        this.queryOrderList();
      }
    },

    //订单列表查询  待付款 - 付款中
    queryOrderList() {
      let params = JSON.parse(JSON.stringify(this.query));
      // if (!this.selectFlag) {
      //   params.pageNum = this.orderTagPage.currentPage;
      //   params.pageSize = this.orderTagPage.pageSize;
      // }

      api.queryOrderList(params).then((res) => {
        if (res.code == '200') {
          if (
            res.data.records instanceof Array &&
            res.data.records.length > 0
          ) {
            this.loading = false;
            this.tableData = res.data.records;
            this.orderTagPage.pageTotal = res.data.total;
            //盐湖的待发货订单
            this.tableData.forEach(async (item) => {
              if (item.orderStatusNum == 31 || item.orderStatusNum == 32) {
                let res1 = await api.salkLakeOrder({
                  companyId: item.purchaseCompanyId,
                });

                if (
                  res1.code == '200' &&
                  res1.data == 'SALTLAKE' &&
                  (item.orderSource == 3 || item.orderSource == 31)
                ) {
                  this.$set(item, 'showDeliverFlag', false);
                } else {
                  this.$set(item, 'showDeliverFlag', true);
                }
              } else {
                this.$set(item, 'showDeliverFlag', false);
              }
            });
          } else {
            this.tableData = [];
            this.orderTagPage.pageTotal = 0;
          }
        }
      });

      this.selectFlag = false;
    },
    //针对生产 特定供应商临时调用 订单列表接口
    queryEMaoListOrder() {
      let params = JSON.parse(JSON.stringify(this.query));
      // if (!this.selectFlag) {
      //   params.pageNum = this.orderTagPage.currentPage;
      //   params.pageSize = this.orderTagPage.pageSize;
      // }

      api.queryEMaoListOrder(params).then((res) => {
        if (res.code == '200') {
          if (
            res.data.records instanceof Array &&
            res.data.records.length > 0
          ) {
            this.loading = false;
            this.tableData = res.data.records;
            this.orderTagPage.pageTotal = res.data.total;
            //盐湖的待发货订单
            this.tableData.forEach(async (item) => {
              if (item.orderStatusNum == 31 || item.orderStatusNum == 32) {
                let res1 = await api.salkLakeOrder({
                  companyId: item.purchaseCompanyId,
                });

                if (
                  res1.code == '200' &&
                  res1.data == 'SALTLAKE' &&
                  (item.orderSource == 3 || item.orderSource == 31)
                ) {
                  this.$set(item, 'showDeliverFlag', false);
                } else {
                  this.$set(item, 'showDeliverFlag', true);
                }
              } else {
                this.$set(item, 'showDeliverFlag', false);
              }
            });
          } else {
            this.tableData = [];
            this.orderTagPage.pageTotal = 0;
          }
        }
      });

      this.selectFlag = false;
    },
    handleSelectionChangeClear() {
      this.query.orderNo = null;
      this.query.orderStatus = null;
      this.query.purchaseCompany = null;
      this.query.startTime = null;
      this.query.endTime = null;
      this.query.startAmount = null;
      this.query.endAmount = null;
      this.submitTime = null;
    },
    formatOrderSource(val) {
      let res = '';
      switch (val) {
        case 1:
          res = '普通订单';
          break;
        case 2:
          res = '普通订单';
          break;
        case 3:
          res = '一体化订单';
          break;
        case 4:
          res = '询比价订单';
          break;
        case 5:
          res = '融合集成订单';
          break;
        case 6:
          res = '普通订单';
          break;
        case 9:
          res = '招标订单';
          break;
        case 10:
          res = '非标订单';
          break;
        case 31:
          res = '融合集成订单';
          break;
        case 11:
        case 12:
        case 13:
          res = '合金不锈订单';
          break;
      }
      return res;
    },
    //判断是否盐湖集团计划采购订单
    async isSalkLakOrder(item) {
      let params = {
        companyId: item.purchaseCompanyId,
      };
      if (item.orderStatusNum == '31' || item.orderStatusNum == '32') {
        let res = await api.salkLakeOrder(params);

        if (res.code == '200') {
          if (
            res.data == 'SALTLAKE' &&
            (item.orderSource == 3 || item.orderSource == 31)
          ) {
            return false;
          }
        }
        return true;
      }
    },
  },
};
</script>

<style lang="scss">
.order-manage {
  .condition {
    .c {
      display: flex;
      ::v-deep .el-input {
        width: 180px;
      }
    }
  }

  .color-red {
    color: #f0250f;
  }

  // .button {
  //   width: 80px;
  //   height: 30px;
  //   line-height: 30px;
  //   text-align: center;
  //   border: 1px solid #2587ff;
  //   color: #2587ff;
  //   cursor: pointer;
  // }
}
.operate {
  display: flex;
  justify-content: center;
  // div {
  //   margin-right: 10px;
  //   color: #0064c8;
  //   cursor: pointer;
  //   border-bottom: 1px solid transparent;
  //   &:hover {
  //     border-bottom: 1px solid #0064c8;
  //   }
  // }
}
.mk10 {
  width: 160px !important;
}

.mt10 {
  width: 360px;
}

.pagination {
  display: flex;
  justify-content: flex-end;
}

.container {
  margin-bottom: 10px;
}

.purchaseCompany {
  margin: 20px 0 14px 0;
}

.message {
  display: flex;
  align-items: center;
  color: rgb(0, 100, 200);
  cursor: pointer;
  justify-content: center;
  margin-bottom: 10px;

  img {
    width: 18px;
    margin-right: 6px;
  }
}
::v-deep .el-table tr {
  height: 20px;
}

::v-deep .el-table__row {
  height: 50px;
}

::v-deep .el-table__header tr,
.el-table__header th {
  padding: 0;
  height: 20px;
}

.el-table__header tr,
.el-table__header th {
  padding: 0;
  height: 40px;
  line-height: 40px;
}

.el-table__body tr,
.el-table__body td {
  padding: 0;
  height: 50px;
  line-height: 50px;
}
.btn {
  color: #2587ff;
  cursor: pointer;
  margin-right: 4px;
}
</style>
